import React from "react";
import get from "lodash/get";
import map from "lodash/map";
import { connect } from "react-redux";
import {
  Alert,
  Button,
  Checkbox,
  Col,
  Form,
  Icon,
  Input,
  InputNumber,
  Select,
  message,
  Modal,
  Row,
} from "antd";
import { withNamespaces } from "react-i18next";
import classes from "./WizardConfig.css";

import {
  generateConfigData,
  generateConfigDataCSV,
  getSimulationSchemaRequest,
  simulatePermutedBlocksConfigDataCSV,
} from "../../api/requests";
import { logout } from "../../reducers/user/actions";
import { v4 as uuidv4 } from "uuid";

class PermutedBlocksSimulationForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoadingData: false,
      isLoading: false,
      errorMessage: null,
      stratGroupsKeys: [],
      dataType: null,
      generatedData: null,
      generatedDataSimulation: null,
      simulateModalOpen: false,
      simulationSchema: null,
    };
  }

  componentDidMount() {
    this.getSchema();
  }

  getSchema = async () => {
    try {
      const { data } = await getSimulationSchemaRequest();
      const simulations = {};
      data.forEach((item) => {
        simulations[item.group] = simulations[item.group]
          ? [...simulations[item.group], item]
          : [item];
      });

      this.setState({
        simulationSchema: simulations,
      });
    } catch (e) {
      console.log(e);
    }
  };

  handleSubmit = () => {
    this.props.form.validateFields(async (err, values) => {
      this.setState({
        isSubmitted: true,
        requestResult: {},
      });

      if (!err) {
        this.setState({ isLoading: true });

        try {
          const data = { ...values };
          if (values.block_sizes) {
            data.block_sizes = values.block_sizes.split(",");
            for (let i = 0; i < data.block_sizes.length; i++) {
              data.block_sizes[i] = data.block_sizes[i].trim();
            }
          }

          if (values.groups) {
            data.groups = values.groups.split(",");
            for (let i = 0; i < data.groups.length; i++) {
              data.groups[i] = data.groups[i].trim();
            }
          }

          const dataSimulate = { ...data };

          const result = await simulatePermutedBlocksConfigDataCSV(
            dataSimulate
          );

          const blob = new Blob([result.data]);
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = `permuted-blocks-simulate-list.csv`;
          link.click();

          this.setState({
            isLoading: false,
            requestResult: {
              type: "success",
              message: this.props.i18n.t("Success"),
            },
            // simulateModalOpen: false,
          });
        } catch (e) {
          console.log(e);
          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }
          this.setState({
            isLoading: false,
            requestResult: {
              type: "error",
              message: JSON.stringify(get(e, "response.data", "Error")),
            },
          });

          if (get(e, "response.data.errors")) {
            const errors = {};
            Object.keys(get(e, "response.data.errors")).forEach(
              (errorFieldKey) => {
                errors[errorFieldKey] = {
                  value: values[errorFieldKey],
                  errors: get(e, `response.data.errors.${errorFieldKey}`).map(
                    (errorMessage) => new Error(errorMessage)
                  ),
                };
              }
            );
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  render() {
    const { isLoading, requestResult, simulationSchema } = this.state;
    const { getFieldDecorator } = this.props.form;

    return (
      <div>
        <Button
          type="primary"
          size="small"
          htmlType="button"
          onClick={(e) => {
            this.setState({
              simulateModalOpen: true,
            });
          }}
          disabled={isLoading}
          loading={isLoading}
        >
          {this.props.i18n.t("Run a simulation")}
        </Button>
        <Modal
          visible={this.state.simulateModalOpen}
          onCancel={() =>
            this.setState({
              simulateModalOpen: false,
            })
          }
          footer={null}
        >
          <h5 className="headline">{this.props.i18n.t("Run a simulation")}</h5>
          {this.state.simulateModalOpen && (
            <Form onSubmit={this.handleSubmit}>
              <Row gutter={8}>
                <Col sm={24}>
                  <Form.Item label={this.props.i18n.t("Subject count")}>
                    {getFieldDecorator("subject_count", {
                      rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    })(<InputNumber placeholder="100" />)}
                  </Form.Item>
                </Col>
                <Col sm={24}>
                  <Form.Item label={this.props.i18n.t("Simulation count")}>
                    {getFieldDecorator("simulation_count", {
                      rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    })(<InputNumber placeholder="1" />)}
                  </Form.Item>
                </Col>

                {simulationSchema && <Col sm={24}>
                  {map(Object.keys(simulationSchema), (simulationGroup) => (
                  <Row gutter={12} key={simulationGroup}>
                    {map(simulationSchema[simulationGroup], ({ fieldName, label, isRequired }) => (
                      <Col lg={6} key={fieldName}>
                        <label>
                          <b>{label}</b>
                          <Form.Item>
                            {getFieldDecorator(fieldName, {
                              rules: [{ required: isRequired, message: this.props.i18n.t("Required") }],
                              initialValue: get(this.props, fieldName, ""),
                            })(
                              <InputNumber
                                style={{ width: "100%" }}
                                placeholder={label}
                              />
                            )}
                          </Form.Item>
                        </label>
                      </Col>
                    ))}
                  </Row>
                ))}
                </Col>}

                <Col sm={24}>
                  {requestResult && requestResult.type && (
                    <Alert
                      message={requestResult.message}
                      type={requestResult.type}
                      className={classes.submitResult}
                    />
                  )}
                </Col>
              </Row>
              <Row gutter={8}>
                <Col span={24}>
                  <Button
                    type="primary"
                    htmlType="button"
                    onClick={(e) => {
                      this.props.form.validateFields(async (err) => {
                        if (!err) {
                          this.setState({ dataType: "simulation" }, () => {
                            this.handleSubmit();
                          });
                        }
                      });
                    }}
                    disabled={isLoading}
                    loading={isLoading}
                  >
                    {this.props.i18n.t("Run a simulation")}
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = { logout };

export default Form.create({ name: "PermutedBlocksSimulationForm" })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(PermutedBlocksSimulationForm))
);



// WEBPACK FOOTER //
// ./src/containers/WizardConfig/PermutedBlocksSimulationForm.js